import type { SVGProps } from 'react';

interface ShotSelectLogoProps extends SVGProps<SVGSVGElement> {
  title?: string;
}

export function ShotSelectLogo({ title = 'ShotSelect', ...props }: ShotSelectLogoProps) {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
      data-testid="shotselect-logo"
      {...props}
    >
      <rect width="64" height="64" rx="14" fill="#ffffff" />
      <text
        x="32"
        y="44"
        textAnchor="middle"
        fill="#0a0a0a"
        fontFamily="-apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, sans-serif"
        fontWeight="800"
        fontSize="30"
      >
        SS
      </text>
    </svg>
  );
}
